import { WorkflowTriggerEnum } from "@finway-group/shared/lib/models"
import { FormInstance } from "antd/lib/form"
import { parseCurrencyInput } from "Components/currencyInput/config"
import i18n from "i18next"
import { RESPONSIBLE_USER_APPROVER } from "../workflowForm/workflow.form"

export const generateRules = (formInstance: FormInstance) => ({
    name: [{ required: true, message: i18n.t("validation:required"), trigger: "blur" }],
    triggerReferenceIds: [
        {
            validator: (_param: any, value: string) => {
                const triggerType = formInstance.getFieldsValue().triggerType
                if (triggerType !== WorkflowTriggerEnum.AMOUNT && value.length === 0) return Promise.reject(i18n.t("validation:required"))

                return Promise.resolve()
            },
        },
    ],
    triggerReferenceValue: [
        {
            validator: (_param: any, value: string) => {
                const triggerType = formInstance.getFieldsValue().triggerType
                if (triggerType === WorkflowTriggerEnum.AMOUNT && !value) return Promise.reject(i18n.t("validation:required"))

                const parsedValue = parseCurrencyInput(value)
                if (parsedValue <= 0) return Promise.reject(i18n.t("validation:greater.number_short", { min: 0 }))

                return Promise.resolve()
            },
        },
    ],
    approver: [
        {
            validator: (rule: any, value: string) => {
                if (!value) return Promise.reject(i18n.t("validation:required"))

                const index = rule.field.split(".")[1]
                const formValues = formInstance.getFieldsValue()

                const secondApprover = formValues.rules[index]?.secondApprover
                if (secondApprover && secondApprover === value) return Promise.reject(i18n.t("validation:duplicate_approver"))

                if (formValues.triggerType === WorkflowTriggerEnum.USER && formValues.triggerReferenceIds.length) {
                    if (formValues.triggerReferenceIds.includes(value)) return Promise.reject(i18n.t("validation:approver_cannot_be_the_requester"))
                }

                if (formValues.triggerType !== WorkflowTriggerEnum.COST_CENTER) {
                    if (value === RESPONSIBLE_USER_APPROVER) return Promise.reject(i18n.t("validation:responsible_employee_only_with_trigger_type_cost_center"))
                }

                return Promise.resolve()
            },
        },
    ],
    secondApprover: [
        {
            validator: (rule: any, value: string) => {
                if (!value) return Promise.reject(i18n.t("validation:required"))

                const index = rule.field.split(".")[1]
                const formValues = formInstance.getFieldsValue()

                const approver = formValues.rules[index]?.approverData
                if (approver && approver === value) return Promise.reject(i18n.t("validation:duplicate_approver"))

                if (formValues.triggerType === WorkflowTriggerEnum.USER && formValues.triggerReferenceIds.length) {
                    if (formValues.triggerReferenceIds.includes(value)) return Promise.reject(i18n.t("validation:approver_cannot_be_the_requester"))
                }

                if (formValues.triggerType !== WorkflowTriggerEnum.COST_CENTER) {
                    if (value === RESPONSIBLE_USER_APPROVER) return Promise.reject(i18n.t("validation:responsible_employee_only_with_trigger_type_cost_center"))
                }

                return Promise.resolve()
            },
        },
    ],
})
